import { Injectable } from '@angular/core';
import { IApiConfig, IApiService } from './api.interface';

@Injectable({
  providedIn: 'root'
})
export abstract class ApiFactoryFacade {
  abstract create(config: IApiConfig): IApiService;
}
